<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="goodsrevenueinfotable"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button  status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '所有税收分类',
				modal_width:1000,
				modal_height:800,
				list_formConfig: [{
					field: 'shortName',
					title: '分类简称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'revenueCode',
					title: '分类名称',
					itemRender: {
						name: '$input'
					}
				}], 
				list_footerField:[
					{field:'needamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				}
				// gridOptions.treeConfig = {
				// 	lazy: false,
				// 	transform: true,
				// 	rowField: 'id',
				// 	parentField: 'parentid',
				// 	line: false,
				// 	expandAll: false,
				// },
				//gridOptions.toolbarConfig.enabled = false
				// gridOptions.toolbarConfig.buttons = [{
				// 	name: '收藏',
				// 	status: 'success',
				// 	code: 'collect'
				// }]
				gridOptions.columns = [{
						type: 'seq',
						title: '序号',
						width:50,
					},{
						field: 'shortName',
						title: '税收分类简称',
					},{
						field: 'revenueName',
						title: '税收分类名称',
					},{
						field: 'revenueCode',
						title: '税收分类编码',
						// filters:[{
						// 	data:''
						// }],
						// filterMethod:this.filterMethod,
						// filterRender:{
						// 	name:'input'
						// }
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.collect(row)}}>收藏</el-button>]
							}
						}
					}
				]
				//gridOptions.formConfig = false
			},
			filterMethod({ option, row ,column }){
				//console.log(column)
				return row[column.field].indexOf(option.data)!==-1
			
			},
			collect(row){
				this.$api.goodsrevenueinfo.collect({id:row.id,collect:1}).then(()=>{
					this.$emit('flashtree')
					this.$message.success('操作成功')
				})	
				//console.log(row)
				//console.log(this.$refs.goodsrevenueinfotable.getCheckboxRecords(true))
	
			},
			list(page,updateForm) {
				//console.log(page,updateForm)
				return new Promise((resolve) => {
					this.$api.goodsrevenueinfo.list({
							all:true,
							...page,
							...updateForm
						}).then((res)=>{
						resolve(res)
					})	

				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>